import React, { useState, useEffect } from "react";
import useAxiosPrivate from "../hooks/useAxiosPrivate";
import { useNavigate } from "react-router-dom";
import useAuth from "../hooks/useAuth";

const Users = () => {
    const [users, setUsers] = useState();
    const axiosPrivate = useAxiosPrivate();
    const navigate = useNavigate();
    const { setAuth } = useAuth();

    useEffect(() => {
        let isMounted = true;
        const controller = new AbortController();

        const getUsers = async () => {
            try {
                const response = await axiosPrivate.get("/users", {
                    signal: controller.signal,
                });
                console.log(response.data);
                isMounted && setUsers(response.data);
            } catch (err) {
                // console.error(err);
                if (err.response?.status === 403) {
                    setAuth({});
                    navigate("/");
                }
            }
        };

        getUsers();

        return () => {
            isMounted = false;
            controller.abort();
        };
    }, []);

    return (
        <>
            <h2>Users List</h2>
            {users?.length ? (
                <ul>
                    {users.map((user) => (
                        <li key={user.username}>{user.username}</li>
                    ))}
                </ul>
            ) : (
                <p>No users to display</p>
            )}
        </>
    );
};

export default Users;
